<template>
  <div
    class="main-content-container scroll-fire-fox"
    :class="{ closed: !sidebarIsOpen }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: ["sidebarIsOpen"]
};
</script>

<style scoped>
.main-content-container {
  width: 100%;
  height: calc(100% - 60px);
  margin-left: 220px;
  margin-top: 60px;
  overflow: hidden;
  overflow-y: auto;
}
.main-content-container.closed {
  margin-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/Content.vue